<div class="header-container" [ngClass]="{ 'dark-theme': theme, 'light-theme': !theme }">
  <div class="controls">
    <app-notification-center *ngIf="showNotificationCenter"></app-notification-center>
    <!-- Help Icon -->
    <button
      nz-button
      nzType="primary"
      nz-tooltip
      nzTooltipTitle="{{ 'HELP.TOOLTIP_TITLE' | translate }}"
      (click)="openHelpDrawer()"
      class="help-button"
      data-tour="global-help"
    >
      <span nz-icon nzType="question-circle" nzTheme="outline" class="help-icon"></span> {{ 'HELP.LABEL' | translate }}
    </button>
    <!-- Language Selector -->
    <nz-select
      [(ngModel)]="selectedLanguage"
      (ngModelChange)="switchLanguage($event)"
      class="language-selector"
      nzPlaceHolder="Language"
      [ngClass]="{ 'dark-select': theme, 'light-select': !theme }"
      [nzDropdownMatchSelectWidth]="false"
      [nzSuffixIcon]="langSuffixTpl"
      [nzDropdownClassName]="'lang-dd'"
    >
      <nz-option
        *ngFor="let lang of languages"
        [nzValue]="lang.value"
        [nzLabel]="lang.label"
        nzCustomContent
      >
        <img
          [src]="'assets/flags/4x3/' + lang.flag + '.svg'"
          alt=""
          width="20"
          height="15"
          class="lang-flag"
          aria-hidden="true"
        />
        <span class="lang-label">{{ lang.label }}</span>
      </nz-option>
    </nz-select>

    <!-- flag shown on the closed select -->
    <ng-template #langSuffixTpl>
      <img
        [src]="'assets/flags/4x3/' + selectedFlag + '.svg'"
        alt=""
        width="20"
        height="15"
        class="lang-flag"
        aria-hidden="true"
      />
    </ng-template>

    <!-- Theme Switcher -->
<!--    <nz-switch-->
<!--      [ngModel]="theme"-->
<!--      [nzCheckedChildren]="checkedTemplate"-->
<!--      [nzUnCheckedChildren]="unCheckedTemplate"-->
<!--      (ngModelChange)="toggleTheme()"-->
<!--    ></nz-switch>-->
<!--    <ng-template #checkedTemplate><span nz-icon nzTheme="outline" nzType="bulb"></span></ng-template>-->
<!--    <ng-template #unCheckedTemplate><span nz-icon nzTheme="outline" nzType="moon"></span></ng-template>-->

    <!-- Profile + always-visible logout button (no caret, tooltip bottom) -->
    <div class="profile-area">
      <button
        nz-button
        nzType="default"
        class="logout-button"
        (click)="logout()"
      >
        <span nz-icon nzType="logout" nzTheme="outline"></span>
        {{ 'LOGIN.LOGOUT' | translate }}
      </button>

      <span
        nz-tooltip
        nzTooltipTitle="{{ userName }}"
        [nzTooltipPlacement]="['bottom', 'bottomRight', 'bottomLeft']"
        class="profile-button"
        role="img"
        aria-label="Profile"
      >
        <img [src]="userProfilePic" alt="Profile" class="profile-picture" />
      </span>
    </div>
  </div>
</div>
<!-- Help Drawer -->
<nz-drawer
  [nzVisible]="isHelpDrawerVisible"
  [nzWrapClassName]="'scanafy-help-drawer'"
  nzTitle="{{ 'HELP.DRAWER_TITLE' | translate }}"
  nzPlacement="right"
  [nzWidth]="drawerWidth"
  [nzClosable]="true"
  nzCloseIcon="close-circle"
[nzMask]="true"
[nzMaskClosable]="true"
  [nzBodyStyle]="{ 'padding': '20px', 'font-size': '14px', 'line-height': '1.6', 'overflow-x': 'hidden' }"
(nzOnClose)="closeHelpDrawer()"
>
  <ng-container *nzDrawerContent>
    <app-help-center-drawer *ngIf="isHelpDrawerVisible" (productTourRequested)="startProductTour()"></app-help-center-drawer>
  </ng-container>
</nz-drawer>
